import React, { useMemo, useRef } from "react";
import "../../Assets/Css/Appreciation.scss";
import Table from "../../Components/Table";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import qs from "query-string";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import CustomCalendar from '../../Components/CustomCalendar';
import AppreciationIcon from '../../Assets/Images/Appreciation/Appreciation'
import TrophyIcon from '../../Assets/Images/Appreciation/Trophy'
import { getAppreciations } from "../../Services/Appreciation/action";
import { deleteRecord } from "../../Services/Delete/action";
import moment from "moment";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../Lib/RoleWiseFeatureWrapper";
import ModulesList from "../../Assets/ModulesLiist";
import FeaturesList from "../../Assets/FeaturesList";
import Skeleton from "react-loading-skeleton";

const Appreciation = (props) => {
    const [checked, setChecked] = useState(false);
    const [selectedId, setSelectedId] = useState([]);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [activeButton, setActiveButton] = useState("");

    const fileInputRef = useRef(null);
    const modalRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Appreciation,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Appreciation,
        Featur_Name: FeaturesList.Delete,
    });
    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Appreciation,
        Featur_Name: FeaturesList.Update,
    });

    useEffect(() => {
        const path = location.pathname;
        setActiveButton(path.split('/').pop())
    }, []);

    const handleClickBtn = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
        console.log(buttonId, "name button")
    };

    const header = [
        // { field: "checkbox" },
        { field: "Given To" },
        { field: "Award Name" },
        { field: "Given On" },
        { field: "Action" },
    ];

    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        setIsLoading(true)
        fetchData();
        setIsLoading(false)
    }, [location.search]);

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props.getAppreciations();
        } catch (error) {
            console.error("Error fetching invoices:", error);
        }
    };

    const showToastMessage = (error) => {
        toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
        });
    };

    useEffect(() => {
        props?.appreciation
            ? setInData(
                props?.user?.role?.name === 'employee'
                    ? props?.appreciation?.filter((item) => item?.given_to_employeeId == props?.user?.id)?.map((item) => {
                        return {
                            "Given To": {
                                image: item?.user?.profile_pic ? `data:image/jpeg;base64,${btoa(
                                    new Uint8Array(item.user.profile_pic.data).reduce(
                                        (data, byte) => data + String.fromCharCode(byte),
                                        ''
                                    )
                                )}` : '',
                                value: item?.user?.name,
                                value2: item?.user?.designation?.name,
                                type: "image_round",
                            },
                            "Award Name": {
                                icon: item?.award?.icon,
                                value: item?.award?.title,
                                value2: item?.award?.icon_background_color,
                                type: 'award',
                            },
                            "Given On": {
                                value: moment(item?.date).format("DD-MM-YYYY"),
                                type: "date",
                            },
                            Action: {
                                value2: "/appreciation/view",
                                value: "/appreciation/edit",
                                value3: item?.id,
                                type: "action",
                            },
                            allData: {
                                ...item
                            }
                        };
                    })
                    : props?.appreciation?.map((item) => {
                        return {
                            "Given To": {
                                image: item?.user?.profile_pic ? `data:image/jpeg;base64,${btoa(
                                    new Uint8Array(item.user.profile_pic.data).reduce(
                                        (data, byte) => data + String.fromCharCode(byte),
                                        ''
                                    )
                                )}` : '',
                                value: item?.user?.name,
                                value2: item?.user?.designation?.name,
                                type: "image_round",
                            },
                            "Award Name": {
                                icon: item?.award?.icon,
                                value: item?.award?.title,
                                value2: item?.award?.icon_background_color,
                                type: 'award',
                            },
                            "Given On": {
                                value: moment(item?.date).format("DD-MM-YYYY"),
                                type: "date",
                            },
                            Action: {
                                value2: "/appreciation/view",
                                value: "/appreciation/edit",
                                value3: item?.id,
                                type: "action",
                            },
                            allData: {
                                ...item
                            }
                        };
                    })
            )
            : setInData([]);
    }, [props?.appreciation]);

    const handleClose = () => {
        setShowModal(false);
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
                setFileName('');
                setSelectedFile(null);
                fileInputRef.current.value = null;
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClose]);

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
                await handlePdfDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);


    let path = '/appreciation/add';
    const handleAddClick = () => {
        navigate(path);
    }

    const initialState = {
        awardname: "",
        employeename: "",
    }

    const [clientData, setClientData] = useState(initialState);

    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const applyFilters = ({ startDate, endDate, awardSearch, employeeSearch }) => {
        setFilteredStartDate(filteredStartDate || startDate);
        setFilteredEndDate(filteredEndDate || endDate);
        const filtered = inData?.filter((leave) => {
            let matchesEmployeeSearch = true;
            let matchesDate = true;
            let matchesAwardSearch = true;

            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                const itemStartDate = moment(leave?.["Given On"]?.value, "DD-MM-YYYY").startOf('day');
                const itemDueDate = leave?.["Given On"]?.value
                    ? moment(leave?.["Given On"]?.value, "DD-MM-YYYY").startOf('day')
                    : itemStartDate;


                const filterStart = moment(filteredStartDate || startDate, "DD-MM-YYYY").startOf('day');
                const filterEnd = moment(filteredEndDate || endDate, "DD-MM-YYYY").endOf('day');

                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');

            }
            if (employeeSearch) {
                matchesEmployeeSearch = leave?.["Given To"]?.value?.toLowerCase()?.includes(employeeSearch?.toLowerCase());
            }
            if (awardSearch) {
                matchesAwardSearch = leave?.["Award Name"]?.value?.toLowerCase()?.includes(awardSearch?.toLowerCase());
            }
            return matchesEmployeeSearch && matchesDate && matchesAwardSearch;
        });
        setFilteredData(filtered);
    };

    const handleClear = () => {
        setClientData({
            awardname: "",
            employeename: ""
        });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    }

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value
        }))
        setSearchTerm(value);
        applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, awardSearch: value, employeeSearch: clientData?.employeename });
    }

    const searchFiledEmployee = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value
        }))
        setSearchTerm(value);
        applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, awardSearch: clientData?.awardname, employeeSearch: value });
    }

    const [activeIcon, setActiveIcon] = useState('left');

    const clickButton = (iconType) => {
        setActiveIcon(iconType);
        if (iconType === 'left') {
            navigate('/appreciation');
        } else if (iconType === 'right') {
            navigate('/award');
        }
    };

    return (
        <div className="appreciation-main">

            <div className="page-title">
                {
                    props.loading ? (
                        <Skeleton className='rounded-2' width={200} height={40} />
                    ) : (
                        <h4> Appreciation </h4>
                    )
                }
                <div>
                    {
                        props.loading ? (<Skeleton className='badge rounded-pill' width={100} height={40} />) : (
                            <RoleWiseFeatureWrapper
                                modules={props?.modules}
                                features={props?.features}
                                user={props?.user}
                                ModuleName={ModulesList.Appreciation}
                                Featur_Name={FeaturesList.Create}>

                                <button className="custom-appreciation-btn" disabled={props.loading} onClick={handleAddClick}>
                                    Add Appreciation
                                </button>
                            </RoleWiseFeatureWrapper>
                        )
                    }
                </div>
            </div>
            <div className="row" style={{ marginBottom: "10px", marginTop: "5px" }}>
                <div className="col-lg-4">
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width="100%" height={40} />
                        ) : (
                            <div className="input-group">
                                <CustomCalendar
                                    inData={inData}
                                    searchTerm={searchTerm}
                                    setFilteredData={setFilteredData}
                                    applyFilters={(params) => { applyFilters(params) }}
                                    startDate={filteredStartDate}
                                    endDate={filteredEndDate}
                                    setStartDate={setFilteredStartDate}
                                    setEndDate={setFilteredEndDate} />

                            </div>
                        )
                    }
                </div>
                <div className="col-lg-4">
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width="100%" height={40} />
                        ) : (
                            <div className="input-group">
                                <input type="text" className="input-css" name='awardname' placeholder='Search Award Name' onChange={searchFiled} />
                            </div>
                        )
                    }
                </div>

                <div className="col-lg-3">
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width="100%" height={40} />
                        ) : (
                            <div className="input-group">
                                <input type="text" className="input-css" name='employeename' placeholder='Search Employee Name' onChange={searchFiledEmployee} />
                            </div>
                        )
                    }
                </div>

                <div className="col-lg-1">
                    {(clientData?.awardname || clientData?.employeename || filteredData?.length > 0 || dateStatus) && (
                        props.loading ? (
                            <Skeleton className='badge rounded-pill' width={50} height={40} />
                        ) : (
                            <button
                                className="export-btn"
                                disabled={props.loading}
                                onClick={handleClear}
                            >
                                Clear
                            </button>
                        )
                    )}
                </div>
            </div>

            <div className="gap-4 addappreciation-export-btn">
                <div>


                    {/* <button
                            className="export-btn"
                            id="exportBtn"
                            disabled={!checked || exportLoading}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClick(totalSelectedIds, "export");
                            }}
                        >
                            {exportLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    className="custom-spinner"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                "Export"
                            )}
                        </button> */}


                </div>


                {
                    props.loading ? (
                        <Skeleton className="rounded-2" width={40} height={40} />
                    ) : (
                        <div className="navigation_btn" style={{ marginBottom: "15px" }}>
                            <RoleWiseFeatureWrapper
                                modules={props?.modules}
                                features={props?.features}
                                user={props?.user}
                                ModuleName={ModulesList.Appreciation}
                                Featur_Name={FeaturesList.View}>
                                <button
                                    className={`btn1 ${activeButton === "appreciation" ? "active" : ""}`}
                                    onClick={() => handleClickBtn("appreciation", "/appreciation")}
                                >
                                    <AppreciationIcon color={activeButton === "appreciation" ? "white" : "black"} bgColor={activeButton === "appreciation" ? "black" : "transparent"} />
                                </button>
                            </RoleWiseFeatureWrapper>

                            <RoleWiseFeatureWrapper
                                modules={props?.modules}
                                features={props?.features}
                                user={props?.user}
                                ModuleName={ModulesList.Award}
                                Featur_Name={FeaturesList.View}>
                                <button
                                    className={`btn1 ${activeButton === "award" ? "active" : ""}`}
                                    onClick={() => handleClickBtn("award", "/award")}
                                >
                                    <TrophyIcon color={activeButton === "award" ? "white" : "black"} bgColor={activeButton === "award" ? "black" : "transparent"} />
                                </button>
                            </RoleWiseFeatureWrapper>
                        </div>
                    )
                }
            </div>

            <div className="invoice-table-part">
                {
                    props.loading ? (
                        <Skeleton className="rounded-2" count={5} width="100%" height={40} />
                    ) : (
                        <Table
                            header={header}
                            data={(clientData?.awardname || clientData?.employeename || dateStatus) ? filteredData : inData}
                            footer={footer}
                            count={count}
                            checked={checked}
                            records={count}
                            totalSelectedIds={totalSelectedIds}
                            defaultParams={params}
                            selectedId={selectedId}
                            handleChange={handleChange}
                            loading={props.loading}
                            showIsView={canView}
                            showIsEdit={canEdit}
                            showIsDelete={canDelete}
                            deleteRecord={props?.deleteRecord}
                        />
                    )
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.appreciationReducer.loading,
        appreciation: state.appreciationReducer.appreciation,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getAppreciations: () => {
            dispatch(getAppreciations())
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue))
            await dispatch(getAppreciations());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Appreciation);
